import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { clearAppcuesIdentity } from "./appcuesIdentifyPolicy";

/**
 * LSP-23357: sign-out clears who we track, so the next person on this browser is not tracked as the last
 * user. api._setDatadogContext sets the Datadog user and org again on the next /me, and App.vue identifies
 * Appcues again after sign-in.
 *
 * - Datadog RUM and Logs: clear the user and the account (org), and end the RUM session so the next person
 *   starts a new session and replay.
 * - Appcues: clearAppcuesIdentity() resets the SDK and removes the user it keeps in browser storage.
 *
 * Never throws: sign-out must not depend on telemetry.
 */
export function clearTrackedIdentity(): void {
	// RUM and Logs are set up separately, so one failing must not skip the other.
	try {
		datadogRum.clearUser();
		datadogRum.clearAccount();
		datadogRum.stopSession();
	} catch (error) {
		console.error("Error clearing the Datadog identity on sign-out", error);
	}
	try {
		datadogLogs.clearUser();
		datadogLogs.clearAccount();
	} catch (error) {
		console.error("Error clearing the Datadog identity on sign-out", error);
	}
	clearAppcuesIdentity();
}
